// extracted by mini-css-extract-plugin
export default {"closeButton":"ta8LSkLO77YdyfvK0ECg"};